import {
	IcoArrowDown,
	IcoArrowUp,
	IcoChild,
	IcoPet,
	IcoUser
} from "assets/icons";
import { TravelInfoProps } from "./types";

import styles from "./styles.module.scss";

export default function TravelInfo({ trip }: TravelInfoProps) {
	const requestAt = new Date(trip?.created_at);
	const requestDate = requestAt.toLocaleDateString("pt-BR");
	const requestTime = requestAt.toLocaleTimeString("pt-BR");

	const departureTrips =
		trip?.points?.filter((point: any) => point.direction === "going") || [];

	const arrivalTrips =
		trip?.points?.filter((point: any) => point.direction === "return") || [];

	const formatDateTime = (datetime: string) => {
		const date = new Date(datetime);
		return {
			date: date.toLocaleDateString("pt-BR"),
			time: date.toLocaleTimeString("pt-BR", {
				hour: "2-digit",
				minute: "2-digit"
			})
		};
	};

	const numberAdults = trip?.num_adults || 0;
	const numberChildren = trip?.num_children || 0;
	const numberPets = trip?.num_pets || 0;

	const preferences = [];
	if (trip.reclining_seats) preferences.push("Banco reclinável / Leito");
	if (trip.tv) preferences.push("TV");
	if (trip.cooler) preferences.push("Frigobar");
	if (trip.wifi) preferences.push("Wi-fi");
	if (trip.bluetooth) preferences.push("Bluetooth");
	if (trip.bilingual_driver) preferences.push("Motorista bilíngue");
	if (trip.trunk) preferences.push("Bagageiro");

	const distance = trip?.distance_km || 0;
	const price = trip?.estimated_cost
		? `R$ ${parseFloat(trip.estimated_cost).toFixed(2).replace(".", ",")}`
		: "R$ 0,00";

	return (
		<div className={styles.container}>
			<span>
				Solicitação recebida em: {requestDate} às {requestTime}
			</span>
			<div className={styles.travelInfo}>
				<span className={styles.title}>Dados da solicitação</span>
				{departureTrips.length > 0 && (
					<div className={styles.travelSection}>
						<span className={styles.subtitle}>
							Ida - {formatDateTime(departureTrips[0].datetime).date} -{" "}
							{formatDateTime(departureTrips[0].datetime).time}
						</span>
						{departureTrips.map((point: any, idx: number) => {
							return (
								<div key={idx} className={styles.travelItinerary}>
									<div className={styles.travelIcon}>
										{point.type === "origin" && <IcoArrowUp />}
										{point.type === "destination" && <IcoArrowDown />}
									</div>
									<div className={styles.content}>
										<span className={styles.pointTitle}>
											Ponto de {point.type === "origin" && "partida"}
											{point.type === "destination" && "chegada"}
											{point.type === "stop" && "parada"}
										</span>
										<span className={styles.pointAddress}>
											{point.address} - {point.city} - {point.state}
										</span>
									</div>
								</div>
							);
						})}
					</div>
				)}

				{arrivalTrips.length > 0 && (
					<div className={styles.travelSection}>
						<span className={styles.subtitle}>
							Volta - {formatDateTime(arrivalTrips[0].datetime).date} -{" "}
							{formatDateTime(arrivalTrips[0].datetime).time}
						</span>
						{arrivalTrips.map((point: any, idx: number) => {
							return (
								<div key={idx} className={styles.travelItinerary}>
									<div className={styles.travelIcon}>
										{point.type === "origin" && <IcoArrowUp />}
										{point.type === "destination" && <IcoArrowDown />}
									</div>
									<div className={styles.content}>
										<span className={styles.pointTitle}>
											Ponto de {point.type === "origin" && "partida"}
											{point.type === "destination" && "chegada"}
											{point.type === "stop" && "parada"}
										</span>
										<span className={styles.pointAddress}>
											{point.address} - {point.city} - {point.state}
										</span>
									</div>
								</div>
							);
						})}
					</div>
				)}

				<div className={styles.travelDetails}>
					<span>Passageiros</span>
					<div className={styles.content}>
						<div className={styles.adultInfo}>
							<IcoUser width="14" height="16" />
							<span>
								{numberAdults} adulto{numberAdults !== 1 ? "s" : ""}
							</span>
						</div>
						<div className={styles.childrenInfo}>
							<IcoChild />
							<span>
								{numberChildren} criança{numberChildren !== 1 ? "s" : ""}
							</span>
						</div>
						<div className={styles.petsInfo}>
							<IcoPet />
							<span>
								{numberPets} pet{numberPets !== 1 ? "s" : ""}
							</span>
						</div>
					</div>
					<span>Preferências</span>
					<div className={styles.content}>
						{preferences.length === 0 ? (
							<span>Nenhuma preferência selecionada</span>
						) : (
							preferences.map((pref) => <span>{pref}</span>)
						)}
					</div>
				</div>
				<div className={styles.travelSummary}>
					<div className={styles.content}>
						<span>Distância total</span>
						<span>{distance} km</span>
					</div>
					<div className={styles.content}>
						<span>Valor da viagem</span>
						<span className={styles.price}>{price}</span>
					</div>
					<div className={styles.disclaimer}>
						<span>
							Inclusos: combustível, pedágios, motorista e taxas de serviço.
						</span>
						<span>
							Custos extras como tarifas de turismo e hospedagem, estacionamento
							e zona azul não estão incluídos.
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}
